import React from 'react';

const Forbidden = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        height: '100%',
        backgroundColor: '#f5f5f5',
        flexDirection: 'column',
      }}
    >
      <h1 style={{ fontWeight: 'bold', fontSize: '48px', color: '#F54927' }}>403</h1>
      <h2 style={{ margin: '16px 0' }}>ACCESS DENIED</h2>
      <p style={{ color: '#555' }}>You do not have permission to access this page.</p>
    </div>
  );
};

export default Forbidden;
